<ts-badge [variant]="variant()" [text]="status_display_name" [class]="class" />
